<template>
  <Modal class="show" v-if="open" :open="open" :title="title" @closeModal="closeModal">
    <router-view />
  </Modal>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import Modal from '@/core/shared/components/Modal';

@Component({
  components: {
    Modal,
  },
})
export default class OverviewModals extends Vue {
  get open () {
    return this.$route.name === 'booking-detail' || this.$route.name === 'closing-detail' || this.$route.name === 'walkin' || this.$route.name === 'paid-extension';
  }

  get title () {
    switch (this.$route.name) {
    case 'booking-detail':
      return this.$t('Reservation Details');
    case 'closing-detail':
      return this.$t('Temporary Closing Details');
    case 'walkin':
      return this.$t('Walk-In');
    case 'paid-extension':
      return this.$t('Paid Extension');
    }
  }

  closeModal () {
    if (window.innerWidth < 768) {
      this.$router.go(-1);
    } else {
      this.$router.push({ name: 'overview' });
    }
  }
}
</script>
